
import { Provide, Mixins } from 'vue-property-decorator';
import LiveCourses from './LiveCourses.vue';
export default class NonLiveCourses extends Mixins(LiveCourses) {
    @Provide() public coursesType: any = 'non-live';
}
